<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import {
  BModal,
  BButton,
  BAlert,
  BRow,
  BCol,
  BFormGroup,
  BFormCheckbox,
  AlertPlugin,
  BForm,
  BFormInput,
} from 'bootstrap-vue';
import vSelect from 'vue-select';
import { required, email } from '@core/utils/validations/validations';

export default {
  components: {
    BFormInput,
    BForm,
    BModal,
    BButton,
    BAlert,
    vSelect,
    BRow,
    BCol,
    BFormGroup,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        empresaid: '',
        empresanome: '',
        empresamodalidade: '',
        empresamodalidadedescr: '',
      }),
      require: true,
    },
    titleModal: {
      type: String,
      default: null,
      require: false,
    },
    idModal: {
      type: String,
      default: null,
      require: false,
    },
    labelBtnOk: {
      type: String,
      default: null,
      require: false,
    },
  },
  computed: {
    dataForm: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    async validateForm() {
      // this.$emit('ok', this.dataForm)
      this.$bvModal.hide(this.idModal);
    },
  },
};
</script>

<template>
  <b-modal
      no-close-on-backdrop
      no-close-on-esc
      size="xl"
      :id="idModal"
      :title="titleModal"
      :ok-disabled="dataForm.isDefault || dataForm.empresanome === ''"
      :ok-title="labelBtnOk"
      ok-variant="success"
      cancel-variant="secondary"
      body-bg-variant="light"
      cancel-title="Cancelar"
      @ok="validateForm"
      @cancel="$emit('cancel')"
      @close="$emit('cancel')"
  >
    <validation-observer ref="refFormData">
      <b-form @submit.prevent>
        <b-row>
<!--          <b-col-->
<!--              cols="6"-->
<!--              -->
<!--          >-->
<!--            <b-form-group-->
<!--                label="Codigo"-->
<!--                label-for="empresaid"-->
<!--            >-->
<!--              <b-form-input-->
<!--                  id="empresaid"-->
<!--                  v-model="dataForm.empresaid"-->
<!--              />-->
<!--            </b-form-group>-->
<!--          </b-col>-->
          <b-col
              cols="6"

          >
            <b-form-group
                label="Nome Fantasia"
                label-for="empresanomefantasia"
            >
              <b-form-input
                  id="empresanomefantasia"
                  v-model="dataForm.empresanomefantasia"
                  type="text"
                  disabled
              />
            </b-form-group>
          </b-col>
          <b-col
              cols="6"

          >
            <b-form-group
                label="Razao Social"
                label-for="empresarazaosocial"
            >
              <b-form-input
                  id="empresarazaosocial"
                  v-model="dataForm.empresarazaosocial"
                  type="text"
                  disabled
              />
            </b-form-group>
          </b-col>
          <b-col
              cols="6"

          >
            <b-form-group
                label="Nome Server"
                label-for="empresaappserver_name"
            >
              <b-form-input
                  id="empresaappserver_name"
                  v-model="dataForm.empresaappserver_name"
                  type="text"
                  disabled
              />
            </b-form-group>
          </b-col>
          <b-col
              cols="6"

          >
            <b-form-group
                label="Url"
                label-for="empresaappserver_url"
            >
              <b-form-input
                  id="empresaappserver_url"
                  v-model="dataForm.empresaappserver_url"
                  type="text"
                  disabled
              />
            </b-form-group>
          </b-col>
          <b-col
              cols="6"

          >
            <b-form-group
                label="Operação"
                label-for="empresaappserver_operation_mode"
            >
              <b-form-input
                  id="empresaappserver_operation_mode"
                  v-model="dataForm.empresaappserver_operation_mode"
                  type="text"
                  disabled
              />
            </b-form-group>
          </b-col>
          <b-col
              cols="6"

          >
            <b-form-group
                label="Usuario"
                label-for="empresaappserver_user"
            >
              <b-form-input
                  id="empresaappserver_user"
                  v-model="dataForm.empresaappserver_user"
                  type="text"
                  disabled
              />
            </b-form-group>
          </b-col>
          <b-col
              cols="6"

          >
            <b-form-group
                label="Senha"
                label-for="empresaappserver_password"
            >
              <b-form-input
                  id="empresaappserver_password"
                  v-model="dataForm.empresaappserver_password"
                  type="text"
                  disabled
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </b-modal>
</template>
